import { render, staticRenderFns } from "./quickBIViewer.vue?vue&type=template&id=ad35dbaa&"
import script from "./quickBIViewer.vue?vue&type=script&lang=js&"
export * from "./quickBIViewer.vue?vue&type=script&lang=js&"
import style0 from "./quickBIViewer.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports